/* eslint-disable */
import React from 'react'
import { Field, change, Form } from 'redux-form'
import { connect } from 'react-redux'
import { reduxForm, SubmissionError } from 'redux-form'

import { validateTag, validatePlate } from './utils'
import { gqlQuery } from 'alelo-logic/services/common/apolloClient'
import {
  Container,
  InputContainer,
  SearchInput,
  SearchButton,
  SearchInputWrapper,
  Error,
  Loading,
  Valid,
  SearchIconContainer
} from './styles'
import imgLoading from '../../../../../static/loading.gif'
import { validPlateOrIdQuery, gqlHistoricoIdentificadorTag } from '../../query'
import InputTagOptions from './InputTagOptions'
import SearchIcon from '../../../../elements/Icons/SearchIcon'

const renderSearchInput = (props) => {
  const invalidInput = props.meta.invalid || props.meta.submitFailed
  return (
    <SearchInputWrapper hide={props.hide}>
      <SearchIconContainer>
        <SearchIcon />
      </SearchIconContainer>
      <SearchInput
        {...props.input}
        disabled={props.plateIsValid}
        invalidInput={invalidInput}
        plateIsValid={props.plateIsValid}
        onChange={(e) => {
          props.input.onChange(e.target.value)
          if (props.option === 'placa') {
            return props.meta.dispatch(change('statementsFilter', 'plate', e.target.value))
          }
        }}
        value={props.input.value}
        type="text"
        placeholder={props.placeholder}
      />
      {invalidInput && <Error>{props.meta.error || props.formError}</Error>}
      {props.plateIsValid && <Valid>Placa ou tag válida</Valid>}
    </SearchInputWrapper>
  )
}

class FilterByTag extends React.Component {
  state = {
    option: 'placa',
  }

  setOption = (value) => this.setState({ option: value })

  submit = async (values) => {
    this.props.setLoading(true)
    if(values.validPlate){
      const response = await gqlQuery(validPlateOrIdQuery, {
        idConta: this.props.accountPlans.activePlanId,
        placa: values.validPlate,
        ...(values.validPlate && { placa: values.validPlate }),
        ...(values.identificador && { identificador: values.identificador }),
      })
      
      if (response.data.identificadoresPJV2.identificadores.length > 0) {
        this.props.setPlateValidation(true)
        this.props.setLoading(false)
        this.props.dispatch(change('statementsFilter', 'plate', response.data.identificadoresPJV2.identificadores[0].veiculo.placa))
        return Promise.resolve()
      } 
    }
    if(values.identificador){
      let response2
      try {
        response2 = await gqlQuery(gqlHistoricoIdentificadorTag, {
          idConta: this.props.accountPlans.activePlanId,
          identificador: values.identificador
        })
      } catch(err){
        this.props.setPlateValidation(false)
        this.props.setLoading(false)
        throw new SubmissionError({ _error: `Essa ${values.identificador ? `tag` : `placa`} não é valida!` })
      }
      if(response2.data.historicoIdentificadorTag.historicos.length > 0){
        this.props.setPlateValidation(true)
        this.props.setLoading(false)
        let placas = response2.data.historicoIdentificadorTag.historicos.map(function(historico) {
          return historico.placa;
        }).join();
        this.props.dispatch(change('statementsFilter', 'plate', placas))
        return Promise.resolve()
      }
    }
    this.props.setPlateValidation(false)
    this.props.setLoading(false)
    throw new SubmissionError({ _error: `Essa ${values.identificador ? `tag` : `placa`} não é valida!` })
 
  }

  render() {
    const {
      handleSubmit,
      error,
      plateIsValid,
      loading,
      dispatch,
      setPlateValidation,
    } = this.props
    const { option } = this.state
    return (
      <Form onSubmit={handleSubmit(this.submit)}>
        <Container>
          <InputContainer>
            <Field
              component={renderSearchInput}
              formError={error}
              plateIsValid={plateIsValid}
              name="validPlate"
              hide={option === 'tag'}
              validate={validatePlate}
              placeholder="Buscar por placa"
            />
            <Field
              component={renderSearchInput}
              formError={error}
              plateIsValid={plateIsValid}
              name="identificador"
              hide={option === 'placa'}
              validate={validateTag}
              placeholder="Buscar por tag"
            />
            <SearchButton type="submit" plateIsValid={plateIsValid}>
              {loading ? <Loading src={imgLoading} /> : `Buscar`}
            </SearchButton>
          </InputContainer>
          <InputTagOptions
            setPlateValidation={setPlateValidation}
            setOption={this.setOption}
            name="placaOrIdOptions"
            value={option}
            dispatch={dispatch}
          />
        </Container>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({ accountPlans: state.reducer.accountPlans })

export default reduxForm({
  form: 'checkPlateOrIdForm',
})(connect(mapStateToProps)(FilterByTag))



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/FilterByTag/FilterByTag.js